import Grid from "@material-ui/core/Grid";
import React, {FunctionComponent, Fragment} from 'react';
import {IPathFinder} from '../../../../types/IPathFinder';
import PhotoRoute from './PhotoRoute/PhotoRoute';

interface IPhotoRoutesItems {
    pathFinder: IPathFinder;
}

const PhotoRoutesItems:FunctionComponent<IPhotoRoutesItems> = ({pathFinder}) => {
    const items = (pathFinder.data ?? []).map((item, idx) =>
        <PhotoRoute
            key={item.id}
            photoData = {item}
            positionNumber = {idx + 1}
        />
    );

    return (
        <Grid container wrap="wrap">
            {items}
        </Grid>
    )
};

export default PhotoRoutesItems
